"use strict";
/* ===================================================================================== @preserve =
 ___  _   _    _
/   || | | |  | |
\__  | | | |  | |  __
/    |/  |/_) |/  /  \_/\/
\___/|__/| \_/|__/\__/  /\_/
              |\
              |/
Ajaxinate
version v2.0.4
https://github.com/Elkfox/Ajaxinate
Copyright (c) 2017 Elkfox Co Pty Ltd
https://elkfox.com
MIT License
================================================================================================= */

var Ajaxinate = function ajaxinateConstructor(config) {
  var settings = config || {};
  /*
    pagination: Selector of pagination container
    container: Selector of repeating content
    offset: 0, offset the number of pixels before the bottom to start loading more on scroll
    loadingText: 'Loading', The text changed during loading
    callback: null, function to callback after a new page is loaded
  */

  var defaultSettings = {
    method: "scroll",
    container: "#AjaxinateContainer",
    pagination: "#AjaxinatePagination",
    offset: 0,
    loadingText: "Loading...",
    callback: null,
  }; // Merge configs

  this.settings = Object.assign(defaultSettings, settings);
  this.addScrollListeners = this.addScrollListeners.bind(this);
  this.addClickListener = this.addClickListener.bind(this);
  this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
  this.stopMultipleClicks = this.stopMultipleClicks.bind(this);
  this.removeClickListener = this.removeClickListener.bind(this);
  this.removeScrollListener = this.removeScrollListener.bind(this);
  this.destroy = this.destroy.bind(this);
  this.containerElement = document.querySelector(this.settings.container);
  this.paginationElement = document.querySelector(this.settings.pagination);
  this.initialize();
};

Ajaxinate.prototype.initialize =
  function initializeTheCorrectFunctionsBasedOnTheMethod() {
    if (this.containerElement) {
      var initializers = {
        click: this.addClickListener,
        scroll: this.addScrollListeners,
      };
      initializers[this.settings.method]();
    }
  };

Ajaxinate.prototype.addScrollListeners =
  function addEventListenersForScrolling() {
    if (this.paginationElement) {
      document.addEventListener("scroll", this.checkIfPaginationInView);
      window.addEventListener("resize", this.checkIfPaginationInView);
      window.addEventListener(
        "orientationchange",
        this.checkIfPaginationInView
      );
    }
  };

Ajaxinate.prototype.addClickListener = function addEventListenerForClicking() {
  if (this.paginationElement) {
    this.nextPageLinkElement = this.paginationElement.querySelector("a");
    this.clickActive = true;

    if (
      typeof this.nextPageLinkElement !== "undefined" &&
      this.nextPageLinkElement !== null
    ) {
      this.nextPageLinkElement.addEventListener(
        "click",
        this.stopMultipleClicks
      );
    }
  }
};

Ajaxinate.prototype.stopMultipleClicks = function handleClickEvent(event) {
  event.preventDefault();

  if (this.clickActive) {
    this.nextPageLinkElement.innerText = this.settings.loadingText;
    this.nextPageUrl = this.nextPageLinkElement.href;
    this.clickActive = false;
    this.loadMore();
  }
};

Ajaxinate.prototype.checkIfPaginationInView = function handleScrollEvent() {
  var top =
    this.paginationElement.getBoundingClientRect().top - this.settings.offset;
  var bottom =
    this.paginationElement.getBoundingClientRect().bottom +
    this.settings.offset;

  if (top <= window.innerHeight && bottom >= 0) {
    this.nextPageLinkElement = this.paginationElement.querySelector("a");
    this.removeScrollListener();

    if (this.nextPageLinkElement) {
      this.nextPageLinkElement.innerText = this.settings.loadingText;
      this.nextPageUrl = this.nextPageLinkElement.href;
      this.loadMore();
    }
  }
};

Ajaxinate.prototype.loadMore =
  function getTheHtmlOfTheNextPageWithAnAjaxRequest() {
    this.request = new XMLHttpRequest();

    this.request.onreadystatechange = function success() {
      if (this.request.readyState === 4) {
        if (this.request.status === 200) {
          // Check if we have a valid responseXML
          if (!this.request.responseXML) {
            console.error(
              "⚠️ Ajaxinate: No responseXML received - this might be a temporary network issue"
            );
            console.log(
              "Response status:",
              this.request.status,
              "Response text length:",
              this.request.responseText?.length || 0
            );
            // Don't hide pagination immediately - could be a temporary issue
            // Let the user try again by clicking the load more button
            if (this.clickActive !== undefined) {
              this.clickActive = true; // Re-enable clicking for manual retry
            }
            return;
          }

          var newContainer = this.request.responseXML.querySelectorAll(
            this.settings.container
          )[0];
          var newPagination = this.request.responseXML.querySelectorAll(
            this.settings.pagination
          )[0];

          console.log("🔍 Ajaxinate response analysis:");
          console.log("- Container selector:", this.settings.container);
          console.log("- Pagination selector:", this.settings.pagination);
          console.log("- newContainer found:", !!newContainer);
          console.log("- newPagination found:", !!newPagination);
          console.log("- Response URL:", this.nextPageUrl);

          if (newContainer) {
            console.log(
              "- Container innerHTML length:",
              newContainer.innerHTML?.length || 0
            );
            console.log(
              "- Container has product items:",
              newContainer.querySelectorAll(".product_item").length
            );
          }

          // Check if both container and pagination exist before proceeding
          if (
            newContainer &&
            newContainer.innerHTML &&
            newContainer.innerHTML.trim() !== ""
          ) {
            this.containerElement.insertAdjacentHTML(
              "beforeend",
              newContainer.innerHTML
            );

            // Only update pagination if it exists and has content, otherwise hide the pagination element
            if (
              newPagination &&
              newPagination.innerHTML &&
              newPagination.innerHTML.trim() !== ""
            ) {
              this.paginationElement.innerHTML = newPagination.innerHTML;
              console.log(
                "✅ Successfully loaded more content and updated pagination"
              );
            } else {
              // No more pages, hide pagination
              this.paginationElement.style.display = "none";
              console.log(
                "🏁 No more pages to load - hiding pagination (legitimate end of pagination)"
              );
              if (
                this.settings.callback &&
                typeof this.settings.callback === "function"
              ) {
                this.settings.callback(this.request.responseXML);

                let queryParams = new URLSearchParams(window.location.search);
                let productImagePicker = queryParams.get("image");
                if (productImagePicker) {
                  FacetFiltersForm.slideToSwiperImageInner(productImagePicker);
                }
              }
              return;
            }

            if (
              this.settings.callback &&
              typeof this.settings.callback === "function"
            ) {
              this.settings.callback(this.request.responseXML);

              let queryParams = new URLSearchParams(window.location.search);
              let productImagePicker = queryParams.get("image");
              if (productImagePicker) {
                FacetFiltersForm.slideToSwiperImageInner(productImagePicker);
              }
            }

            this.initialize();
          } else {
            console.error(
              "⚠️ Ajaxinate: Container element not found or empty in response"
            );
            console.log(
              "newContainer:",
              newContainer,
              "innerHTML length:",
              newContainer?.innerHTML?.length || 0
            );
            // This might indicate we've reached the end, but let's be more careful
            // Only hide if we're confident there's no more content
            if (!newContainer || !newContainer?.innerHTML?.trim()) {
              this.paginationElement.style.display = "none";
              console.log("🏁 No more content available - hiding pagination");
            }
          }
        } else {
          console.error(
            "⚠️ Ajaxinate: HTTP error",
            this.request.status,
            this.request.statusText
          );
          this.paginationElement.style.display = "none";
        }
      }
    }.bind(this);

    this.request.open("GET", this.nextPageUrl);
    this.request.responseType = "document";
    this.request.send();
  };

Ajaxinate.prototype.removeClickListener = function removeClickEventListener() {
  this.nextPageLinkElement.removeEventListener(
    "click",
    this.stopMultipleClicks
  );
};

Ajaxinate.prototype.removeScrollListener =
  function removeScrollEventListener() {
    document.removeEventListener("scroll", this.checkIfPaginationInView);
    window.removeEventListener("resize", this.checkIfPaginationInView);
    window.removeEventListener(
      "orientationchange",
      this.checkIfPaginationInView
    );
  };

Ajaxinate.prototype.destroy = function removeEventListenersAndRemoveThis() {
  var destroyers = {
    click: this.removeClickListener,
    scroll: this.removeScrollListener,
  };
  destroyers[this.settings.method]();
  return this;
};
